import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'status'];
  static values = { completed: Array };

  completedValueChanged() {
    const completed = new Set(this.completedValue);

    this.itemTargets.forEach((item, index) => {
      const done = completed.has(item.dataset.key);
      item.dataset.done = done;
      if (this.statusTargets[index]) this.statusTargets[index].textContent = done ? 'complete' : 'not complete';
    });
  }
}
